import { ApiService, Clinic } from "pwapi";

import SelectSearchInput from "../edit/SelectSearchInput";

const mapClinicToOptions = (clinics: Clinic[]) => [
  { value: "", label: "All Clinics", object: "All Clinics" },
  ...clinics
    .filter((clinic) => clinic.name)
    .map((clinic) => ({
      value: clinic.name,
      label: clinic.name,
      object: clinic.name,
    })),
];

const Selection = ({ object }: any) => {
  return <>{object}</>;
};

const ClinicFilter = ({
  onChange,
  value,
}: {
  onChange: Function;
  value?: string;
}) => {
  return (
    <SelectSearchInput
      label="Clinic"
      field="clinic"
      filter="name"
      onChange={onChange}
      mapToOptions={mapClinicToOptions}
      apiService={ApiService.listClinics}
      component={Selection}
    >
      <Selection object={value || "All Clinics"} />
    </SelectSearchInput>
  );
};

export default ClinicFilter;
